export enum TargetCase {
  CAMEL,
  SCREAMING_SNAKE,
}

export function convertCase(inputString: string, targetCase: TargetCase): string {
  switch (targetCase) {
    case TargetCase.CAMEL:
      return inputString?.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    case TargetCase.SCREAMING_SNAKE:
      return inputString?.replace(/[A-Z]/g, (match) => `_${match}`).toUpperCase();
  }
}
